import { hasNoValue } from '@util';

export const dateComparator = (left: Date, right: Date) => {
  if (hasNoValue(left) && hasNoValue(right)) {
    return 0;
  }

  if (hasNoValue(left)) {
    return -1;
  }

  if (hasNoValue(right)) {
    return 1;
  }

  const leftTime = left.getTime();
  const rightTime = right.getTime();

  if (leftTime === rightTime) {
    return 0;
  }

  return leftTime > rightTime ? 1 : -1;
};
